import PropTypes from "prop-types";
import "./BaseComponent.styles.css";

export default function BaseComponent({ children }) {
  return <div className="base-styles-body">{children}</div>;
}

BaseComponent.propTypes = {
  children: PropTypes.any,
};
